
import saveAs from "file-saver";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";

import docxtemplater from "docxtemplater";

function loadFile(url: any, callback: any) {
    PizZipUtils.getBinaryContent(url, callback);
}

export function createAndSaveDocument(pFileName: string, pTemplatePath: string, pData: any) {
    loadFile(pTemplatePath, function (error: any, content: any) {
        if (error) {
            throw error;
        }
        const zip = new PizZip(content);
        const doc = new docxtemplater().loadZip(zip);
        doc.setData(pData);
        try {
            doc.render();
        } catch (error) {
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }
        // docx generating
        const out = doc.getZip().generate({
            type: "blob",
            mimeType:
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        saveAs(out, pFileName + `.docx`); // You can pass this blob to a custom file saver component in the project.
    });
}